<template>
  <div class="page-style">
    <b-row>
      <b-col cols="3">
        <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
      </b-col>

      <b-col cols="6" class="pt-4"> </b-col>

      <b-col cols="3" class="pl-5">
        <b-row><field-label :label="'ID. Relatório'" :field="laudo.numero" /></b-row>
        <b-row><field-date-label :label="'Data'" :field="laudo.data" /></b-row>
      </b-col>
    </b-row>
    <hr />

    <div class="page-body font-title">
      <b-row>
        <b-col cols="12" :style="{ marginTop: 200 + 'px' }">
          <p>LAUDO TÉCNICO</p>
        </b-col>

        <b-col cols="12" :style="{ marginTop: 50 + 'px' }">
          <b-img
            :src="laudo.imgFirstPage == null ? require('/static/images/report.png') : laudo.imgFirstPage"
            class="max-size-img"
            center
            fluid
          />
        </b-col>
        <b-col cols="12" :style="{ marginTop: 200 + 'px' }">
          <h2>{{ equipamento.nome }}</h2>
        </b-col>
        <b-col cols="12">
          <h1>{{ "SGCQ Nº: " + equipamento.sgcq }}</h1>
        </b-col>
      </b-row>
    </div>

    <hr />
    <b-row>
      <h5 class="ml-4">{{ laudo.rodape }}</h5>
    </b-row>
  </div>
</template>

<script>
import FieldAndLabel from "@/components/reports/parts/FieldAndLabel";
import FieldDateAndLabel from "@/components/reports/parts/FieldDateAndLabel";

export default {
  name: "FirstLaudoTecnicoReport",

  props: ["laudo", "equipamento"],

  components: {
    "field-label": FieldAndLabel,
    "field-date-label": FieldDateAndLabel,
  },

  data() {
    return {};
  },

  methods: {},

  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.page-style {
  width: 100%;
}

.page-body {
  height: 1300px;
}

.font-title {
  font-family: fantasy;
  font-weight: 400;
  text-align: center;
  font-size: 4em;
}
</style>
